import { createElement } from 'react';

import {
  createFrontendPlugin,
  PageBlueprint,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import AssessmentIcon from '@mui/icons-material/Assessment';

import { rootRouteRef } from './routes';

const scorecardsEntityTab = EntityContentBlueprint.make({
  name: 'scorecards-tab',
  params: {
    path: '/scorecards',
    title: 'Scorecards',
    filter: 'kind:group',
    routeRef: rootRouteRef,
    loader: async () => {
      const [{ TeamScoreCard }, { ScorecardDataProvider }] = await Promise.all([
        import('./components/TeamScorecard'),
        import('./context/ScorecardDataContext'),
      ]);
      return (
        <ScorecardDataProvider>
          <TeamScoreCard />
        </ScorecardDataProvider>
      );
    },
  },
});

const scorecardsPage = PageBlueprint.make({
  name: 'scorecards',
  params: {
    path: '/scorecards',
    title: 'Scorecards',
    icon: createElement(AssessmentIcon),
    loader: async () => {
      const { OperationalExcellencePage } = await import(
        './pages/OperationalExcellencePage/OperationalExcellencePage'
      );
      return createElement(OperationalExcellencePage);
    },
  },
});

const allScorecardsPage = PageBlueprint.make({
  name: 'all-scorecards',
  params: {
    path: '/all-scorecards',
    title: 'All Scorecards',
    icon: createElement(AssessmentIcon),
    loader: async () => {
      const { AllScorecardsPage } = await import(
        './pages/AllScorecardsPage/AllScorecardsPage'
      );
      return createElement(AllScorecardsPage);
    },
  },
});

export const scorecardsPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'scorecard-frontend',
  extensions: [scorecardsEntityTab, scorecardsPage, allScorecardsPage],
  routes: {
    root: rootRouteRef,
  },
});